<template>
  <div>
    <button v-if="!visible" @click="toggle" class="open-btn">☰</button>
    <transition name="slide">
      <div v-if="visible" class="sidebar">
        <button @click="toggle" class="close-btn">✖</button>
        <div class="content">
          <div class="d-grid gap-2">
            <MapyAutoComplete />
            <MojePolohaButton />
            <UlozMistaP4nButton />
          </div>
          <FiltryMista />
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, provide } from "vue";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";

//import HelloButton from "./HelloButton.vue";
import UlozMistaP4nButton from "./buttons/btUlozMistaP4n.vue";
import MojePolohaButton from "./buttons/MojePolohaButton.vue";
import FiltryMista from "./FiltryMista.vue";
import MapyAutoComplete from "./MapyAutoComplete.vue";
const visible = ref(false);
const toggle = () => (visible.value = !visible.value);

const hide = () => (visible.value = false);

const root = ref(null);

function otevri() {
  visible.value = true;
}

function zavri() {
  visible.value = false;
}

// 💡 zpřístupníme funkci pro jiné komponenty
provide("hideSidebar", hide);

provide("Sidebar.zavri", zavri);

defineExpose({
  visible,
  root,
  hide,
  otevri,
  zavri,
});
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
.slide-enter-to,
.slide-leave-from {
  transform: translateX(0);
}
.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 350px;
  height: 100vh;
  overflow-y: auto;
  background: #fff;
  border-left: 1px solid #ccc;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1100;
  padding: 1em;
}
.content {
  margin-top: 1em;
  margin-bottom: 2em;
}
.open-btn {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1100;
  background: #fff;
  border: 1px solid #ccc;
  padding: 5px 10px;
  cursor: pointer;
  width: 44px;
  height: 47px;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #eee;
  border: none;
  cursor: pointer;
}
</style>
